import { QueryEndpoint } from 'store/queries/types';
import { web3Api } from 'store/queries';

type Web3ApiEndpoints = typeof web3Api.endpoints;

// web3Api.endpoints is keyed by the known endpoint names, but callers resolve an
// endpoint from a runtime string, so we index by the union of endpoint names and
// normalise the heterogeneous endpoint union to a single QueryEndpoint shape.
export const getEndpointByName = (
  name: string,
): QueryEndpoint<unknown, unknown> =>
  web3Api.endpoints[name as keyof Web3ApiEndpoints] as unknown as QueryEndpoint<
    unknown,
    unknown
  >;
